// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optin {
  font-size: 11px;
}

.post-optin {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/LandingsV2/public.css"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;AACJ","sourcesContent":[".optin {\n    font-size:11px;\n}\n\n.post-optin {\n    margin-top:0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
